import { KEYS_FEATURED, KEYS_MODS } from '@config/storeKeys.js'
import modSerializer from '@serializers/modSerializer.js'
import { store } from '@stores'
import { computed } from 'vue'

const { addToStoreData, createStore, updateStore, generateId, getStore } =
  store()

export default function () {
  function getMods(gameNameId) {
    return getStore(generateId(KEYS_MODS, gameNameId))
  }

  function getFeaturedMods(gameNameId, carouselId) {
    return getStore(generateId(KEYS_FEATURED, gameNameId, carouselId))
  }

  function getModByNameId(gameNameId, modNameId) {
    if (!gameNameId) {
      throw new TypeError()
    }

    const mods = getMods(gameNameId)
    modNameId = modNameId?.toLowerCase()

    return computed(() =>
      (mods.value?.data || []).find(
        (mod) => mod.name_id.toLowerCase() === modNameId
      )
    )
  }

  function addMods(gameNameId, mods, query) {
    createStore(generateId(KEYS_MODS, gameNameId), {
      ...modSerializer.transform(mods),
      query,
    })
  }

  function addFeaturedMods(gameNameId, carouselId, mods, query) {
    updateStore(generateId(KEYS_FEATURED, gameNameId, carouselId), {
      ...modSerializer.transform(mods),
      query,
    })
  }

  function removeMods(gameNameId) {
    updateStore(generateId(KEYS_MODS, gameNameId))
  }

  function addMod(gameNameId, mod) {
    const _mod = modSerializer.transform(mod)

    addToStoreData(generateId(KEYS_MODS, gameNameId), _mod)

    return _mod
  }

  return {
    addFeaturedMods,
    getFeaturedMods,
    getModByNameId,
    removeMods,
    addMods,
    getMods,
    addMod,
  }
}
